import 'bootstrap/dist/js/bootstrap.js'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)
